export function scrollIntoView(id) {
    setTimeout(() => {
        const element = document.querySelector(id);
        const header = document.querySelector('.navbar.header');
        if (!element)
            return;
        const rect = element.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        window.scroll({
            top: rect.top + scrollTop - (header ? header.clientHeight : 0),
            behavior: 'smooth'
        });
    }, 200);
}
